import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { styled, Typography } from "@mui/material";
import { fontSize } from "@mui/system";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="right" ref={ref} {...props} />;
});

const WideDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    maxWidth: "1000px",
    width: "80%",
  },
}));

const Subtitle = styled(Typography)(({ theme }) => ({
  padding: "0 24px",
}));

export const DialogSlideRight = ({
  open,
  title,
  subtitle,
  cancelTitle,
  confirmTitle,
  icon: Icon,
  handleClose,
  handleConfirm,
  children,
}: {
  open: boolean;
  title: string;
  subtitle?: JSX.Element;
  cancelTitle: string;
  confirmTitle: string;
  icon?: React.ElementType;
  handleClose: () => void;
  handleConfirm: () => void;
  children?: any;
}) => {
  return (
    <React.Fragment>
      <WideDialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle sx={{display: "flex", alignItems: "center", gap: "12px"}}>
          {Icon && <Icon sx={{fontSize: "30px"}}/>}
          {title}
        </DialogTitle>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}

        <DialogContent>{children}</DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{cancelTitle}</Button>
          <Button onClick={handleConfirm}>{confirmTitle}</Button>
        </DialogActions>
      </WideDialog>
    </React.Fragment>
  );
};
